import React from "react";
import TopBanner from "../../../components/topBanner/topBanner";
import imgBanner from "../../../images/banner/banner-tin-tuc.jpg";
import { useTranslation } from "react-i18next";

const IntroduceStandaloneLayout = ({
  title,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <main className="introduce introduce-standalone">
      <TopBanner
        titleCenter={t("recruitment.title")}
        imgBanner={imgBanner}
        pageName={t("recruitment.title")}
        text={title}
      />
      <div className="layout_container introduce-standalone__container">
        <div className="introduce__content">{children}</div>
      </div>
    </main>
  );
};

export default IntroduceStandaloneLayout;
